import { Store, waitFor } from 'utils';

class ScrollStore extends Store {

	getInitialState() {
		return {
			offset: 0
		}
	}

	onScrollChanged(state, data) {
		state.offset = data.offset;
	}

	onSelectedPavilionChanged(state) {
		state.offset = 0;
	}

	onSelectedStandChanged(state) {
		state.offset = 0;
	}

	getOffset() {
		return this.getState().offset;
	}

}

const store = new ScrollStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/scrollstore.js